import * as constants from '../constants/tags'
import Api from '../services/api.js'

export function updateTagRequest(){
  return {
    type: constants.UPDATE_TAG_REQUEST,
  }
}

export function updateTagSuccess(data){
  return {
    type: constants.UPDATE_TAG_SUCCESS,
    body: data
  }
}

export function updateTagFailure(exception){
  return {
    type: constants.UPDATE_TAG_FAILURE,
    exception: exception
  }
}

export function updateTag(details) {
  return dispatch => {
    dispatch(updateTagRequest())
    const api = new Api();
    return api.put("/api/v1/tags", details)
    .then(response => {
      dispatch(updateTagSuccess(response.data))
    })
    .catch(err => dispatch(updateTagFailure(err)));
  }
}

export function getTagMatrixRequest(){
  return {
    type: constants.GET_TAG_MATRIX_REQUEST,
  }
}

export function getTagMatrixSuccess(body){
  return {
    type: constants.GET_TAG_MATRIX_SUCCESS,
    body: body
  }
}

export function getTagMatrixFailure(exception){
  return {
    type: constants.GET_TAG_MATRIX_FAILURE,
    exception: exception
  }
}

export function getTagMatrix(params) {
  return dispatch => {
    dispatch(getTagMatrixRequest())
    const api = new Api();
    return api.makeRequest({
        method: "get",
        url: `/api/v1/tags/${params.id}/matrix`,
        params: params
      })
      .then(response => {
        dispatch(getTagMatrixSuccess(response.data))
      })
      .catch(err => {
        // error callback
        dispatch(getTagMatrixFailure(err))
      })
      .then(() => {
        // do no matter error or success
      });
  }
}

export function exportToExcel(params) {
  const api = new Api();
  return api.get(`/api/v1/tags/${params.id}/matrix_excel`, { params: params, responseType: 'blob' })
}


export function getComplianceRatingsRequest(){
  return {
    type: constants.GET_COMPLIANCE_RATINGS_REQUEST,
  }
}

export function getComplianceRatingsSuccess(body){
  return {
    type: constants.GET_COMPLIANCE_RATINGS_SUCCESS,
    body: body
  }
}

export function getComplianceRatingsFailure(exception){
  return {
    type: constants.GET_COMPLIANCE_RATINGS_FAILURE,
    exception: exception
  }
}

export function getComplianceRatings(params) {
  return dispatch => {
    dispatch(getComplianceRatingsRequest())
    const api = new Api();
    return api.makeRequest({
        method: "get",
        url: "/api/v1/tags/" + params.id + "/compliances",
        params: params
      })
      .then(response => {
        // success callback
        dispatch(getComplianceRatingsSuccess(response.data))
      })
      .catch(err => {
        // error callback
        dispatch(getComplianceRatingsFailure(err))
      })
      .then(() => {
        // do no matter error or success
      });
  }
}

export function getCompliancesComparisonRequest(){
  return {
    type: constants.GET_COMPLIANCES_COMPARISON_REQUEST,
  }
}

export function getCompliancesComparisonSuccess(body){
  return {
    type: constants.GET_COMPLIANCES_COMPARISON_SUCCESS,
    body: body
  }
}

export function getCompliancesComparisonFailure(exception){
  return {
    type: constants.GET_COMPLIANCES_COMPARISON_FAILURE,
    exception: exception
  }
}

export function getCompliancesComparison(params) {
  return dispatch => {
    dispatch(getCompliancesComparisonRequest())
    const api = new Api();
    return api.makeRequest({
        method: "get",
        url: "/api/v1/compliances_comparison",
        params: params
      })
      .then(response => {
        // success callback
        dispatch(getCompliancesComparisonSuccess(response.data))
      })
      .catch(err => {
        // error callback
        dispatch(getCompliancesComparisonFailure(err))
      })
      .then(() => {
        // do no matter error or success
      });
  }
}



// WEBPACK FOOTER //
// ./src/actions/v2_tags.js